module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'notification/base' && templateVars.config ?
				templateVars.config :
				{
	"setMaxVisible": 3,
	"narrow": true,
	"animation": {
		"duration": 400
	}
};